import { render, staticRenderFns } from "./WasteDealDrawer.vue?vue&type=template&id=4615951d&scoped=true&"
import script from "./WasteDealDrawer.vue?vue&type=script&lang=js&"
export * from "./WasteDealDrawer.vue?vue&type=script&lang=js&"
import style0 from "./WasteDealDrawer.vue?vue&type=style&index=0&id=4615951d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615951d",
  null
  
)

export default component.exports